import React from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'

const CustomDatePicker = (props) => {
    const hasErrors = () => {
        return props.errors && props.errors[props.name]
    }

    const Errors = () => {
        return (
            <div className='inline-error'>{props.errors[props.name][0]}</div>
        )
    }

    const futureDatesOnly = (date) => {
        const today = new Date()
        return today < date
    }

    const selected = () => {
        if (props.value) {
            const selected = props.value
            const format = selected.length > 10 ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'
            const date = moment(props.value, format)

            return new Date(date.toDate())
        }

        return null
    }

    return (
        <div>
            <div className='form-control my-4 my-md-3'>
                {props.label
                    ? <label>
                        {props.label}
                        <br />
                        {props.children}
                      </label>
                    : ''}
                <div className={hasErrors() ? 'error' : ''}>
                    <DatePicker
                        name={props.name}
                        selected={selected()}
                        dateFormat='dd MMM yyyy'
                        onChange={date => props.handleChange({ [props.name]: date })}
                        filterDate={props.filterDate ? props.filterDate : null}
                        minDate={props.minDate ? props.minDate : null}
                        autoComplete='off'
                    />
                    {hasErrors() ? Errors() : ''}
                </div>
            </div>
        </div>
    )
}

export default CustomDatePicker



// WEBPACK FOOTER //
// ./resources/js/elements/CustomDatePicker.js